import { useBoundStore } from "../stores/useBoundStore";

const useSetPreset = () => {
  const setQuad1 = useBoundStore((state) => state.setQuad1);
  const setQuad2 = useBoundStore((state) => state.setQuad2);
  const setQuad3 = useBoundStore((state) => state.setQuad3);
  const setQuad4 = useBoundStore((state) => state.setQuad4);
  const setX = useBoundStore((state) => state.setX);
  const setXCols = useBoundStore((state) => state.setXCols);
  const setY = useBoundStore((state) => state.setY);
  const setYRows = useBoundStore((state) => state.setYRows);
  const setTextTop = useBoundStore((state) => state.setTextTop);
  const setTextBottom = useBoundStore((state) => state.setTextBottom);
  const setTextColor = useBoundStore((state) => state.setTextColor);
  const setTextBGColor = useBoundStore((state) => state.setTextBGColor);
  const setTextBGActive = useBoundStore((state) => state.setTextBGActive);
  const setTextPosition = useBoundStore((state) => state.setTextPosition);
  const setFontFamily = useBoundStore((state) => state.setFontFamily);
  const setBackground = useBoundStore((state) => state.setBackground);
  const setRepetition = useBoundStore((state) => state.setRepetition);
  const setColorScheme = useBoundStore((state) => state.setColorScheme);
  const setHiddenRepetitions = useBoundStore((state) => state.setHiddenRepetitions);
  const setAnimation = useBoundStore((state) => state.setAnimation);

  const setPreset = (preset) => {
    setQuad1(preset.quad1);
    setQuad2(preset.quad2);
    setQuad3(preset.quad3);
    setQuad4(preset.quad4);
    setX(preset.x);
    setXCols(preset.xCols);
    setY(preset.y);
    setYRows(preset.yRows);
    setTextTop(preset.textTop);
    setTextBottom(preset.textBottom);
    setTextColor(preset.textColor);
    setTextBGColor(preset.textBGColor);
    setTextBGActive(preset.textBGActive);
    setTextPosition(preset.textPosition);
    setFontFamily(preset.fontFamily);
    setBackground(preset.background);
    setRepetition(preset.repetition);
    setColorScheme(preset.colorScheme);
    setAnimation(preset.animation);
    setHiddenRepetitions(preset.hiddenRepetitions || []);
  };

  return { setPreset };
};

export default useSetPreset;
